<template>
	<div class="accordion-item" :class="{ 'is-open': isActive }">
		<h3 class="accordion-item-title" :class="{ active: isActive }" @click="toggle">
			<span>{{ name }}</span>
		</h3>

		<transition
			name="accordion"
			@before-enter="handleBeforeEnter"
			@enter="handleEnter"
			@before-leave="handleBeforeLeave"
			@leave="handleLeave"
		>
			<div class="accordion-item-body" v-show="isActive">
				<div class="accordion-item-content">
					<slot></slot>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			required: true,
		},

		selected: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			isActive: false,
		};
	},

	methods: {
		toggle() {
			this.$root.$emit('select-accordion', this);
		},

		handleBeforeEnter(el) {
			el.style.maxHeight = '0';
		},

		handleEnter(el) {
			el.style.maxHeight = el.scrollHeight + 'px';
		},

		handleBeforeLeave(el) {
			el.style.maxHeight = el.scrollHeight + 'px';
		},

		handleLeave(el) {
			el.style.maxHeight = '0';
		},
	},

	mounted() {
		this.isActive = this.selected;
	},
};
</script>

<style lang="stylus" scoped></style>
